import { useHasFeatureFlag } from 'src/featureFlags/useHasFeatureFlag';

export const useESimsAvailable = () => {
  return useHasFeatureFlag('ESims');
};
